import { Link } from "react-router-dom";

const NavbarV2 = () => {
  let publicUrl = process.env.PUBLIC_URL + "/";
  return (
    <div className="navbar-area">
      <div className="adbar-area d-none d-lg-block">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-5 align-self-center">
              <div className="logo text-md-left text-center">
                <Link className="main-logo" to="/">
                  <img
                    src={publicUrl + "assets/img/logo.png"}
                    alt="img"
                    width={150}
                  />
                </Link>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7 text-md-right text-center d-flex justify-content-end align-items-center">
              <ul className="social-area social-area-2">
                <li>
                  <a
                    className="facebook-icon"
                    href="https://www.facebook.com/WeRNews/"
                  >
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                  <a className="twitter-icon" href="https://x.com/WeRNewsLive">
                    <i className="fa-brands fa-x-twitter" />
                  </a>
                </li>
                <li>
                  <a
                    className="youtube-icon"
                    href="https://www.youtube.com/@WeRNewsLive"
                  >
                    <i className="fa fa-youtube-play" />
                  </a>
                </li>
                <li>
                  <a
                    className="instagram-icon"
                    style={{
                      background:
                        "linear-gradient(45deg, #ffdc80, #fcaf45, #f77737, #f56040, #fd1d1d, #e1306c, #c13584, #833ab4)",
                    }}
                    href="https://www.instagram.com/wernewslive/"
                  >
                    <i className="fa fa-instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* adbar end*/}
      {/* navbar start */}
      <nav className="navbar navbar-expand-lg">
        <div className="container nav-container">
          <div className="responsive-mobile-menu">
            <div className="logo d-lg-none d-block">
              <Link className="main-logo" to="/">
                <img src="assets/img/logos.png" alt="img" width={200} />
              </Link>
              <ul className="social-area social-area-2">
                <li>
                  <a
                    className="facebook-icon"
                    href="https://www.facebook.com/WeRNews/"
                  >
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                  <a className="twitter-icon" href="https://x.com/WeRNewsLive">
                    <i className="fa-brands fa-x-twitter" />
                  </a>
                </li>
                <li>
                  <a
                    className="youtube-icon"
                    href="https://www.youtube.com/@WeRNewsLive"
                  >
                    <i className="fa fa-youtube-play" />
                  </a>
                </li>
                <li>
                  <a
                    className="instagram-icon"
                    style={{
                      background:
                        "linear-gradient(45deg, #ffdc80, #fcaf45, #f77737, #f56040, #fd1d1d, #e1306c, #c13584, #833ab4)",
                    }}
                    href="https://www.instagram.com/wernewslive/"
                  >
                    <i className="fa fa-instagram" />
                  </a>
                </li>
              </ul>
            </div>
            <button
              className="menu toggle-btn d-block d-lg-none"
              data-target="#nextpage_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="nav-right-part nav-right-part-mobile d-none">
            <a className="search header-search" href="#">
              <i className="fa fa-search" />
            </a>
          </div>

          <div
            className="collapse navbar-collapse text-center"
            id="nextpage_main_menu"
          >
            <ul className="navbar-nav menu-open">
              <li className="menu-item-has-children current-menu-item">
                <Link to="/">होम </Link>
              </li>
              <li className="menu-item-has-children current-menu-item">
                <Link to="/category/न्यूज़">न्यूज़</Link>
              </li>
              <li className="menu-item-has-children current-menu-item">
                <Link to="/रुबरू-with-राजीव">
                  रुबरू{" "}
                  <span className="with" style={{ textTransform: "lowercase" }}>
                    With
                  </span>{" "}
                  राजीव
                </Link>
              </li>
              <li className="menu-item-has-children current-menu-item">
                <Link to="/web-stories">वेब स्टोरी</Link>
              </li>
              <li className="menu-item-has-children current-menu-item">
                <Link to="/category/मनोरंजन">मनोरंजन</Link>
              </li>
              <li className="menu-item-has-children current-menu-item">
                <Link to="/category/धर्म">धर्म</Link>
              </li>
              <li className="menu-item-has-children current-menu-item">
                <Link to="/category/बिजनेस">बिजनेस</Link>
              </li>{" "}
              <li className="menu-item-has-children current-menu-item">
                <Link to="/category/हेल्थ">हेल्थ</Link>
              </li>
            </ul>
          </div>

          {/* <div className="nav-right-part nav-right-part-desktop">
            <div className="menu-search-inner">
              <input type="text" placeholder="Search For" />
              <button type="submit" className="submit-btn">
                <i className="fa fa-search" />
              </button>
            </div>
          </div> */}
        </div>
      </nav>
     <div className="container sli"> <div className="nav-tags-scroll-container">
        <div className="nav-tags-scroll">
          <button className="nav-tag">
            {" "}
            <Link to="/category/न्यूज़">न्यूज़</Link>
          </button>
          <button className="nav-tag">
            <Link to="/रुबरू-with-राजीव">
              रुबरू{" "}
              <span className="with" style={{ textTransform: "lowercase" }}>
                With
              </span>{" "}
              राजीव
            </Link>
          </button>
          <button className="nav-tag">
            <Link to="/web-stories">वेब स्टोरी</Link>
          </button>
          <button className="nav-tag">
            <Link to="/category/मनोरंजन">मनोरंजन</Link>
          </button>
          <button className="nav-tag">
            <Link to="/category/धर्म">धर्म</Link>
          </button>
          <button className="nav-tag">
            <Link to="/category/बिजनेस">बिजनेस</Link>
          </button>
          <button className="nav-tag">
            <Link to="/category/हेल्थ">हेल्थ</Link>
          </button>
        </div>
      </div></div>
    </div>
  );
};

export default NavbarV2;
